import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { useState, useRef } from 'react';
import EcoinventModal from './EcoinventModal';
import usePatchParams from '../usePatchParams';

const options = [
  {
    label: 'Sesame Default',
    value: 'sesame',
  },
  {
    label: 'Ecoinvent (v3.11)',
    value: 'ecoinvent',
  },
];

const DataSourcesField = ({ paramSchema, param, name }) => {
  const { control } = useFormContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { patchParam, patchGroup } = usePatchParams();
  const {
    data_source: { value },
    // primary: { default: defaultValue },
    dataset_id: { value: datasetId },
  } = param ?? {};
  const fieldName = `data_source.${name}`;
  const { ecoinvent_query: ecoinventQuery } = paramSchema ?? {};

  const handleSelectionChange = async selectedValue => {
    if (selectedValue === 'ecoinvent') {
      setIsModalOpen(true);
    } else {
      await patchParam(name, 'data_source', selectedValue);
      // await patchPrimary(name, defaultValue);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleModalUpdate = async item => {
    const { dataset } = item;
    // await patchPrimary(name, value);

    await patchGroup(name, {
      [name]: {
        data_source: { value: 'ecoinvent' },
        dataset_id: { value: dataset.id },
      },
    });
  };

  return (
    <>
      <Controller
        name={fieldName}
        control={control}
        render={({ field: { onChange, value: fieldValue } }) => (
          <details className="dropdown dropdown-end dropdown-xs" ref={dropdownRef}>
            <summary className="btn btn-xs flex-nowrap border border-gray-400 bg-white font-normal hover:bg-gray-50 text-gray-600 rounded-lg px-2">
              <svg
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="relative"
              >
                <rect x="3" y="10" width="2.5" height="5" rx="1" fill="#F3F4F6" stroke="#A3A3A3" strokeWidth="1.2" />
                <rect x="8.25" y="6" width="2.5" height="9" rx="1" fill="#F3F4F6" stroke="#A3A3A3" strokeWidth="1.2" />
                <rect x="13.5" y="13" width="2.5" height="2" rx="1" fill="#F3F4F6" stroke="#A3A3A3" strokeWidth="1.2" />
              </svg>

              {options.find(opt => opt.value === value)?.label}
            </summary>
            <ul className="dropdown-content text-xs menu bg-white rounded-xl z-[1] w-52 p-2 shadow-lg border border-gray-200 mt-1">
              {options.map(option => (
                <li key={`${name}-${option.value}`}>
                  <a
                    onClick={async () => {
                      onChange(option.value);
                      await handleSelectionChange(option.value);
                      if (dropdownRef.current) {
                        dropdownRef.current.open = false;
                      }
                    }}
                    className={`rounded-lg px-3 py-2 text-gray-700 hover:bg-gray-100 ${
                      fieldValue === option.value || value === option.value ? 'bg-gray-100 font-medium' : ''
                    }`}
                  >
                    {option.label}
                  </a>
                </li>
              ))}
            </ul>
          </details>
        )}
      />
      {isModalOpen && (
        <EcoinventModal
          ecoinventQuery={ecoinventQuery}
          datasetId={datasetId}
          isOpen={isModalOpen}
          onClose={handleModalClose}
          onUpdate={handleModalUpdate}
        />
      )}
    </>
  );
};

DataSourcesField.propTypes = {
  paramSchema: PropTypes.object,
  param: PropTypes.object,
  name: PropTypes.string,
  prefix: PropTypes.string,
};

export default DataSourcesField;
